import './polyfills.ts';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
  document.write('<script>drift.load("x2akzxwz6gun");drift.config({ inboxId: 181215 });</script>')
} else {
  document.write('<script>drift.load("dssxhgnt2u6n-dev");</script>')
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./client/main.ts